<template>
<div class="chapter">
<div class="inner_page">
<h2 class="AHD"><strong>Beautiful Birdie Biscuits</strong></h2>
<h3 class="CAU"><strong>BY RUTH CLEMENS</strong></h3>
<div class="Image"><img alt="" src="OEBPS/images/6-1.jpg"/></div>
<h4 class="CHD"><strong><em>You Will Need:</em></strong></h4>
<p class="ML">Circular biscuits (7.5cm/3in diameter)</p>
<p class="ML">White, blue, purple and pink sugarpaste</p>
<p class="ML">Pink, purple, golden yellow and black royal icing</p>
<p class="ML">Fluted cookie cutter and small round cutter</p>
<p class="ML">Petal cutters, Large, small and extra small rose petal</p>
<div class="SbS1"><strong>1.</strong> Roll out the white sugarpaste to 3mm (<span class="fraction"><sup>1</sup>⁄<sub>8</sub></span>in) thick; cut out a fluted circle. Secure to the top of a biscuit using a little water.</div>
<div class="SbS2"><strong>2.</strong> Roll out the blue sugarpaste to 2mm (<span class="fraction"><sup>3</sup>⁄<sub>32</sub></span>in) thick; cut out the bird’s body using the large petal cutter and use the small round cutter to cut out the bird’s head. Roll out the purple sugarpaste to 2mm (<span class="fraction"><sup>3</sup>⁄<sub>32</sub></span>in) thick and cut out three tail feathers with the extra small petal cutter. Set aside.</div>
<div class="SbS2"><strong>3.</strong> Roll out the pink sugarpaste, to 2mm (<span class="fraction"><sup>3</sup>⁄<sub>32</sub></span>in) thick and cut out a small petal for the bird’s wing.Pinch the thin end of the petal and curve the shape slightly to create the curve of the wing. Use a knife to mark three lines along the wing.</div>
<div class="SbS2"><strong>4.</strong> Start to build the bird onto the biscuit using the pieces you have cut out. Start with the tail feathers securing them in position with a dab of water. Add the body, the head and finally the wing.</div>
<div class="SbS2"><strong>5.</strong> Using the black royal icing, pipe a dot for the bird’s eye and two legs. Add a beak with golden yellow royal icing.</div>
<div class="SbS2"><strong>6.</strong> Finally pipe three pink bulbs between the bird’s feet and tail feathers and three purple bulbs to the right of the bird’s head.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02.vue?28c4d747